import { Component, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';

@Component({
  selector: 'app-dcf-common-textarea',
  standalone: true,
  imports: [CommonModule, FormsModule],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => DcfCommonTextareaComponent), multi: true }],
  template: `
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-1">Textarea</label>
      <textarea
        class="block w-full px-3 py-2 border border-gray-300 rounded-md"
        rows="3"
        [(ngModel)]="value"
        placeholder="Enter text">
      </textarea>
    </div>
  `
})
export class DcfCommonTextareaComponent implements ControlValueAccessor {
  value: string = '';
  private onChange: (value: any) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: any): void { this.value = value || ''; }
  registerOnChange(fn: any): void { this.onChange = fn; }
  registerOnTouched(fn: any): void { this.onTouched = fn; }
  setDisabledState(isDisabled: boolean): void { }
}
